import { useUser } from "../../../context/UserContext";
import RoadMapNiveau from "./RoadMapNiveau";
// import PlanningProgressionCommune from "../PlanningProgressionCommune";

function ProgressionNiveau() {
    const {etablissementData} = useUser();

    return (
      <RoadMapNiveau etablissement={etablissementData} />
    );
}

export default ProgressionNiveau;
